import { createContext } from "react";
const LogContext= createContext();
export default LogContext;